<template>
    <div ref="xinlv"></div>
</template>

<script>

import * as echarts from 'echarts';

export default {
    name: "TiWenChart",
    data() {
        return {
            loading: false
        }
    },
    props: {
        values: {
            type: [String, Array],
            default: ''
        }
    },
    computed: {},
    mounted() {
        this.drawLine()
    },
    methods: {
        drawLine() {
            // 基于准备好的dom，初始化echarts实例
            let myChart = echarts.init(this.$refs.xinlv)
            // 绘制图表
            myChart.setOption({
                // Make gradient line here
                backgroundColor: ['#0e2f6e'], // 全图默认背景
                color:['#19caff'],
                title: {
                    left: 'left',
                    text: '体温',
                    textStyle: {
                        color: '#63B8FF',
                    }
                },
                grid: {
                    bottom: '20px',
                    top: '33px'
                },
                // 提示框组件
                tooltip: {
                    trigger: 'axis' // 触发类型。坐标轴触发，主要在柱状图，折线图等会使用类目轴的图表中使用/none什么都不触发
                },
                xAxis: {
                    data: this.values.map(item => {
                        return item.create_time
                    }),
                    show: false,
                    axisLine:false,
                    splitLine: {
                        interval:0,
                        show: true, // x轴、y轴显示网格线,坐标轴在 grid 区域中的分隔线
                        lineStyle: {
                            // 使用深浅的间隔色--分隔线颜色，可以设置成单个颜色。也可以设置成颜色数组，分隔线会按数组中颜色的顺序依次循环设置颜色。
                            color: '#ffffff22'
                        }
                    }
                },
                yAxis: {
                    max:40,
                    min:30,
                    axisLine:false,
                    splitLine: {
                        show: true, // x轴、y轴显示网格线,坐标轴在 grid 区域中的分隔线
                        lineStyle: {
                            // 使用深浅的间隔色--分隔线颜色，可以设置成单个颜色。也可以设置成颜色数组，分隔线会按数组中颜色的顺序依次循环设置颜色。
                            color: '#ffffff22'
                        }
                    }
                },
                // 系列列表。每个系列通过 type 决定自己的图表类型
                series: {
                    type: 'line', // 线条
                    smooth:true,
                    lineStyle:{
                        width:1
                    },
                    areaStyle: {
                        color: '#19caff55'
                    },
                    showSymbol: false, // 是否显示 symbol符号, 如果 false 则只有在 tooltip hover 的时候显示。
                    data: this.values.map(item => {
                        return item.bodyTemperature
                    })
                }
            });
        }
    },
    watch: {
        values(){
            this.drawLine()
        }
    },
    filters: {}
}
</script>

<style scoped lang="scss">

</style>